import React from 'react';
export var AppboxContent = function (props) {
    return (React.createElement("div", { className: 'appboxcontent-box' },
        React.createElement("div", { className: 'span-box' },
            React.createElement("img", { src: props.img })),
        React.createElement("div", { className: 'app-name ps-2' }, props.appname)));
};
